var _circle, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "url(#paint0_linear_65_389)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_65_389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 10H10V31H31V10Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_65_389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3644 10H15.6885C14.1805 10.0018 12.7348 10.6016 11.6684 11.6678C10.602 12.734 10.002 14.1797 10 15.6876V25.3644C10.0022 26.8724 10.6023 28.3179 11.6686 29.3841C12.735 30.4502 14.1806 31.0501 15.6885 31.0521H25.3644C26.8721 31.0499 28.3174 30.4499 29.3835 29.3837C30.4495 28.3175 31.0492 26.8721 31.0512 25.3644V15.6876C31.0495 14.1799 30.4498 12.7344 29.3837 11.6681C28.3176 10.6019 26.8722 10.002 25.3644 10ZM29.3511 25.3644C29.3495 26.4214 28.9289 27.4345 28.1814 28.1817C27.4338 28.9289 26.4205 29.3491 25.3636 29.3502H15.6885C14.6316 29.3491 13.6182 28.9289 12.8707 28.1817C12.1232 27.4345 11.7026 26.4214 11.701 25.3644V15.6876C11.7023 14.6305 12.1229 13.617 12.8704 12.8695C13.6179 12.122 14.6313 11.7015 15.6885 11.7002H25.3644C26.4215 11.7017 27.4348 12.1223 28.1823 12.8698C28.9298 13.6172 29.3504 14.6306 29.3519 15.6876L29.3511 25.3644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2361 19.7918C25.0764 18.7109 24.5468 17.7188 23.7376 16.9846C22.9285 16.2504 21.8897 15.8195 20.7984 15.7653C19.7072 15.7112 18.6308 16.0371 17.7529 16.6875C16.875 17.338 16.2498 18.2727 15.9838 19.3325C15.7179 20.3923 15.8276 21.5115 16.2944 22.4994C16.7611 23.4873 17.556 24.2828 18.5436 24.7503C19.5311 25.2179 20.6502 25.3285 21.7102 25.0633C22.7702 24.7982 23.7054 24.1737 24.3566 23.2963C24.728 22.7995 24.997 22.2339 25.148 21.6323C25.299 21.0307 25.3289 20.4051 25.2361 19.7918ZM21.01 23.471C20.4181 23.5598 19.8132 23.4709 19.2719 23.2157C18.7306 22.9604 18.2772 22.5503 17.9691 22.0372C17.661 21.5241 17.5121 20.9311 17.5412 20.3333C17.5703 19.7355 17.7761 19.1599 18.1326 18.6791C18.4892 18.1984 18.9803 17.8343 19.5439 17.6329C20.1074 17.4314 20.7181 17.4018 21.2986 17.5476C21.879 17.6935 22.4031 18.0083 22.8045 18.4522C23.206 18.8961 23.4666 19.4492 23.5535 20.0413C23.6144 20.4339 23.5967 20.8346 23.5015 21.2202C23.4062 21.6059 23.2353 21.9688 22.9987 22.2879C22.7621 22.6069 22.4644 22.8758 22.1231 23.0789C21.7817 23.282 21.4033 23.4153 21.01 23.471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4456 14.6024C26.3064 14.4652 26.124 14.3804 25.9293 14.3625C25.7347 14.3445 25.5398 14.3946 25.3779 14.5041C25.216 14.6136 25.0969 14.7758 25.0411 14.9631C24.9853 15.1505 24.996 15.3514 25.0716 15.5317C25.1471 15.7119 25.2828 15.8605 25.4555 15.9521C25.6282 16.0437 25.8273 16.0726 26.0189 16.034C26.2105 15.9953 26.3829 15.8915 26.5066 15.7402C26.6303 15.5889 26.6978 15.3993 26.6976 15.2039C26.6962 14.978 26.6056 14.7619 26.4456 14.6024Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_65_389",
    x1: 0,
    y1: 20.5,
    x2: 41,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18669C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2596A9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.55f31046a3937594f6aa6add6428be16.svg";
export { ForwardRef as ReactComponent };